import React from "react";
import PropTypes from "prop-types";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import VerifiedOutlinedIcon from "@mui/icons-material/VerifiedOutlined";

import { OURO_CODE_INTRO, OURO_CODE_PRINCIPLES } from "./ouroCode";

const ACCENT = "#E8A33D";

export default function OuroCodeDialog({ open, onAccept, onClose }) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      aria-labelledby="ouro-code-title"
    >
      <DialogTitle
        id="ouro-code-title"
        sx={{ display: "flex", alignItems: "center", gap: 1, pb: 1 }}
      >
        <VerifiedOutlinedIcon sx={{ color: ACCENT }} />
        The Ouro Code
      </DialogTitle>
      <DialogContent dividers>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2.5 }}>
          {OURO_CODE_INTRO}
        </Typography>

        <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
          {OURO_CODE_PRINCIPLES.map((principle) => (
            <Box
              key={principle.title}
              sx={{
                display: "flex",
                gap: 1.5,
                alignItems: "flex-start",
              }}
            >
              <Box
                sx={{
                  mt: "7px",
                  flexShrink: 0,
                  width: 6,
                  height: 6,
                  borderRadius: "50%",
                  backgroundColor: ACCENT,
                }}
              />
              <Box>
                <Typography
                  component="span"
                  variant="body2"
                  sx={{ fontWeight: 600, color: "text.primary" }}
                >
                  {principle.title}
                </Typography>{" "}
                <Typography
                  component="span"
                  variant="body2"
                  color="text.secondary"
                >
                  {principle.body}
                </Typography>
              </Box>
            </Box>
          ))}
        </Box>
      </DialogContent>
      <DialogActions sx={{ px: 3, py: 2 }}>
        <Button onClick={onClose} sx={{ color: "text.secondary" }}>
          Not now
        </Button>
        <Button
          onClick={onAccept}
          variant="contained"
          sx={{
            backgroundColor: ACCENT,
            color: "#0B0D0F",
            boxShadow: "none",
            "&:hover": { backgroundColor: "#F4B752", boxShadow: "none" },
          }}
        >
          I'm in
        </Button>
      </DialogActions>
    </Dialog>
  );
}

OuroCodeDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onAccept: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};
